import { classes, media, style } from 'typestyle'

/* Core ========================================================================================= */
import { SnippetdObject } from '../../core/snippet-manager'

/* Components =================================================================================== */
import { Box } from '../../components/box/box.component'

/* Styles ======================================================================================= */
import { createMediaQuery } from '../../components/style-class/style-class.utils'
import { rowmdi } from '../../styles/styleset/row/rowmdi'
import { Fragment } from 'react'

export const renderSnippets = (props: {
  snippets: any[]
  update?: any
  sync?: any
  row?: any
  rows?: any
  $row?: any
  $rows?: any
  $snippetPreset?: any
  offsetTop?: any
}) => {
  const { snippets = [], update, sync, $row, $rows, row, rows, $snippetPreset } = props

  const render = (items: any) =>
    items.map((segment: any, key: any) => {
      let totalSize = 0

      segment.items.map((item: any) => {
        totalSize += item.size || 1
      })

      return (
        <Box
          className={classes(
            rowmdi,
            style({
              width: 'calc(100% + 16px)',
              marginLeft: -8,
              ...media(
                { type: 'print' },
                {
                  width: 'calc(100%)',
                  display: 'flex',
                  marginLeft: 0,
                  flexDirection: 'column',
                },
              ),
            }),
          )}
          baseline="none"
          flex
          spaceBetween
          key={key}
        >
          {segment.items.map((item: any, key2: any) => {
            const containerStyle = style({
              padding: '0 8px',
              zIndex: Math.max(3 - key2, 0),
              ...(() => {
                if (item.fixed) {
                  return {
                    minWidth: 320,
                    maxWidth: 320,
                    position: 'sticky',
                    top: props.offsetTop + 16,
                    height: 'fit-content',
                  }
                }

                if (item.fullSize) {
                  return {
                    width: 'calc(100% - 320px)',
                  }
                }
                return {
                  width:
                    segment.items.length > 1
                      ? `calc(${((item.size || 1) / totalSize) * 100}%)`
                      : '100%',
                }
              })(),
              ...createMediaQuery['md']({
                width: '100%',
                minWidth: '100%',
                maxWidth: '100%',
              }),
              ...media(
                { type: 'print' },
                {
                  width: '100%',
                  display: 'flex',
                  padding: 0,
                  flexDirection: 'column',
                },
              ),
            })

            return (
              <Box className={containerStyle} baseline="none" key={key2}>
                {item.items.map((snippet: any, key3: any) => {
                  if (snippet.type === 'row') {
                    return render([snippet])
                  }

                  if (SnippetdObject[snippet.type]) {
                    const Component = SnippetdObject[snippet.type]

                    return (
                      <Fragment key={key3}>
                        <Box
                          style={{
                            zIndex: item?.items?.length ? item?.items?.length + 1 - key3 : 'inital',
                            position: 'relative',
                          }}
                          baseline="none"
                          className={style({
                            display: snippet.hidden && 'none',
                            ...media(
                              { type: 'print' },
                              {
                                display: snippet.disablePrint ? 'none' : 'flex',
                              },
                            ),
                          })}
                        >
                          <Component
                            {...snippet}
                            trigger={
                              snippet?.sync
                                ?.map((id: string) => sync[id])
                                .sort()
                                .reverse()
                                .filter((a: any) => a)[0]
                            }
                            sync={() => {
                              update(snippet.id)
                            }}
                            $row={$row}
                            $rows={$rows}
                            row={row}
                            rows={rows}
                            $snippetPreset={$snippetPreset}
                          />
                        </Box>
                      </Fragment>
                    )
                  }
                })}
              </Box>
            )
          })}
        </Box>
      )
    })

  return render(snippets)
}
